<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  export let receipts;

  function printReceipt() {
    window.print();
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Receipt Results</svelte:fragment>
  <svelte:fragment slot="tagline">
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <div>
        <span class="fs-5"
          >We found {receipts.length}
          {receipts.length > 1 ? "receipts" : "receipt"} for this vehicle.</span
        >
      </div>
      <div>
        <button class="btn btn-primary" on:click={printReceipt}
          >Print Receipt</button
        >
      </div>
    </div>
  </svelte:fragment>
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="receipt"></span>
    <span slot="list"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-12">
    <Alerts />
    {#each receipts as receipt}
      <div class="card mb-4">
        <div
          class="card-body row align-items-center justify-content-center text-start g-0"
        >
          {@html receipt}
        </div>
      </div>
    {/each}
  </div>
</div>
